/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-63ed8f4f.js';
import '@carbon/icon-helpers';
import React from 'react';
var didWarnAboutDeprecation = {};

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 15H24V17H8z"
});

var SubtractAlt32 = /*#__PURE__*/React.forwardRef(function SubtractAlt32(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref2, _ref3, children);
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 15H24V17H8z"
});

var SubtractAlt24 = /*#__PURE__*/React.forwardRef(function SubtractAlt24(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref5, _ref6, children);
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 15H24V17H8z"
});

var SubtractAlt20 = /*#__PURE__*/React.forwardRef(function SubtractAlt20(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref8, _ref9, children);
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14\tS23.7,2,16,2z"
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 15H24V17H8z"
});

var SubtractAlt16 = /*#__PURE__*/React.forwardRef(function SubtractAlt16(_ref10, ref) {
  var children = _ref10.children,
      rest = _objectWithoutProperties(_ref10, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref11, _ref12, children);
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref21 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sun32 = /*#__PURE__*/React.forwardRef(function Sun32(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, children);
});

var _ref24 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref25 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref26 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref27 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref28 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref29 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref30 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref31 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref32 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sun24 = /*#__PURE__*/React.forwardRef(function Sun24(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, children);
});

var _ref34 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref35 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref36 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref37 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref38 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref39 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref40 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref41 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref42 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sun20 = /*#__PURE__*/React.forwardRef(function Sun20(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, children);
});

var _ref44 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref45 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref46 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref47 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref48 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref49 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref50 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref51 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref52 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sun16 = /*#__PURE__*/React.forwardRef(function Sun16(_ref43, ref) {
  var children = _ref43.children,
      rest = _objectWithoutProperties(_ref43, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, children);
});

var _ref54 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref55 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref56 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref57 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref58 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref59 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref60 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref61 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref62 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sunny32 = /*#__PURE__*/React.forwardRef(function Sunny32(_ref53, ref) {
  var children = _ref53.children,
      rest = _objectWithoutProperties(_ref53, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['Sunny32']) {
      didWarnAboutDeprecation['Sunny32'] = true;
      console.warn("The Sunny32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, children);
});

var _ref64 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref65 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref66 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref67 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref68 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref69 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref70 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref71 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref72 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sunny24 = /*#__PURE__*/React.forwardRef(function Sunny24(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['Sunny24']) {
      didWarnAboutDeprecation['Sunny24'] = true;
      console.warn("The Sunny24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, children);
});

var _ref74 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref75 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref76 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref77 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref78 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref79 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref80 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref81 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref82 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sunny20 = /*#__PURE__*/React.forwardRef(function Sunny20(_ref73, ref) {
  var children = _ref73.children,
      rest = _objectWithoutProperties(_ref73, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['Sunny20']) {
      didWarnAboutDeprecation['Sunny20'] = true;
      console.warn("The Sunny20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, children);
});

var _ref84 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
  transform: "translate(0 .005)"
});

var _ref85 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 5.375H8.854V10.333H6.854z",
  transform: "rotate(-45 7.86 7.856)"
});

var _ref86 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 15.005H7V17.005000000000003H2z"
});

var _ref87 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.375 23.147H10.333V25.147H5.375z",
  transform: "rotate(-45 7.86 24.149)"
});

var _ref88 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 25.005H17V30.005H15z"
});

var _ref89 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
  transform: "rotate(-45 24.152 24.149)"
});

var _ref90 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 15.005H30V17.005000000000003H25z"
});

var _ref91 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
  transform: "rotate(-45 24.152 7.856)"
});

var _ref92 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.005H17V7.005H15z"
});

var Sunny16 = /*#__PURE__*/React.forwardRef(function Sunny16(_ref83, ref) {
  var children = _ref83.children,
      rest = _objectWithoutProperties(_ref83, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['Sunny16']) {
      didWarnAboutDeprecation['Sunny16'] = true;
      console.warn("The Sunny16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, children);
});

var _ref94 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
});

var _ref95 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.146 15.854)"
});

var _ref96 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
});

var _ref97 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.854 15.854)"
});

var _ref98 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22H7V24H2z"
});

var Sunrise32 = /*#__PURE__*/React.forwardRef(function Sunrise32(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref94, _ref95, _ref96, _ref97, _ref98, children);
});

var _ref100 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
});

var _ref101 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.146 15.854)"
});

var _ref102 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
});

var _ref103 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.854 15.854)"
});

var _ref104 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22H7V24H2z"
});

var Sunrise24 = /*#__PURE__*/React.forwardRef(function Sunrise24(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref100, _ref101, _ref102, _ref103, _ref104, children);
});

var _ref106 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
});

var _ref107 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.146 15.854)"
});

var _ref108 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
});

var _ref109 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.854 15.854)"
});

var _ref110 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22H7V24H2z"
});

var Sunrise20 = /*#__PURE__*/React.forwardRef(function Sunrise20(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref106, _ref107, _ref108, _ref109, _ref110, children);
});

var _ref112 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27H29.998V29H2zM16 20a4.0045 4.0045 0 014 4h2a6 6 0 00-12 0h2A4.0045 4.0045 0 0116 20zM25 22H30V24H25z"
});

var _ref113 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.146 15.854)"
});

var _ref114 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4z"
});

var _ref115 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.854 15.854)"
});

var _ref116 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22H7V24H2z"
});

var Sunrise16 = /*#__PURE__*/React.forwardRef(function Sunrise16(_ref111, ref) {
  var children = _ref111.children,
      rest = _objectWithoutProperties(_ref111, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref112, _ref113, _ref114, _ref115, _ref116, children);
});

var _ref118 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27.005H29.998V29.005H2z"
});

var _ref119 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
  transform: "translate(0 .005)"
});

var _ref120 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 22.005H30V24.005H25z"
});

var _ref121 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.152 15.856)"
});

var _ref122 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
});

var _ref123 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.86 15.856)"
});

var _ref124 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22.005H7V24.005H2z"
});

var Sunset32 = /*#__PURE__*/React.forwardRef(function Sunset32(_ref117, ref) {
  var children = _ref117.children,
      rest = _objectWithoutProperties(_ref117, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, children);
});

var _ref126 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27.005H29.998V29.005H2z"
});

var _ref127 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
  transform: "translate(0 .005)"
});

var _ref128 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 22.005H30V24.005H25z"
});

var _ref129 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.152 15.856)"
});

var _ref130 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
});

var _ref131 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.86 15.856)"
});

var _ref132 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22.005H7V24.005H2z"
});

var Sunset24 = /*#__PURE__*/React.forwardRef(function Sunset24(_ref125, ref) {
  var children = _ref125.children,
      rest = _objectWithoutProperties(_ref125, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, children);
});

var _ref134 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27.005H29.998V29.005H2z"
});

var _ref135 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
  transform: "translate(0 .005)"
});

var _ref136 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 22.005H30V24.005H25z"
});

var _ref137 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.152 15.856)"
});

var _ref138 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
});

var _ref139 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.86 15.856)"
});

var _ref140 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22.005H7V24.005H2z"
});

var Sunset20 = /*#__PURE__*/React.forwardRef(function Sunset20(_ref133, ref) {
  var children = _ref133.children,
      rest = _objectWithoutProperties(_ref133, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, children);
});

var _ref142 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 27.005H29.998V29.005H2z"
});

var _ref143 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z",
  transform: "translate(0 .005)"
});

var _ref144 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 22.005H30V24.005H25z"
});

var _ref145 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.668 14.854H26.625999999999998V16.854H21.668z",
  transform: "rotate(-45 24.152 15.856)"
});

var _ref146 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.59 9.595L17 12.175 17 4.005 15 4.005 15 12.175 12.41 9.595 11 11.005 16 16.005 21 11.005 19.59 9.595z"
});

var _ref147 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.854 13.374H8.854V18.332H6.854z",
  transform: "rotate(-45 7.86 15.856)"
});

var _ref148 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 22.005H7V24.005H2z"
});

var Sunset16 = /*#__PURE__*/React.forwardRef(function Sunset16(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, children);
});

var _ref150 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
});

var Svg32 = /*#__PURE__*/React.forwardRef(function Svg32(_ref149, ref) {
  var children = _ref149.children,
      rest = _objectWithoutProperties(_ref149, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref150, children);
});

var _ref152 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
});

var Svg24 = /*#__PURE__*/React.forwardRef(function Svg24(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref152, children);
});

var _ref154 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
});

var Svg20 = /*#__PURE__*/React.forwardRef(function Svg20(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref154, children);
});

var _ref156 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM8 23H2V21H8V17H4a2 2 0 01-2-2V11A2 2 0 014 9h6v2H4v4H8a2 2 0 012 2v4A2 2 0 018 23z"
});

var Svg16 = /*#__PURE__*/React.forwardRef(function Svg16(_ref155, ref) {
  var children = _ref155.children,
      rest = _objectWithoutProperties(_ref155, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref156, children);
});

var _ref158 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
});

var Swim32 = /*#__PURE__*/React.forwardRef(function Swim32(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref158, children);
});

var _ref160 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
});

var Swim24 = /*#__PURE__*/React.forwardRef(function Swim24(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref160, children);
});

var _ref162 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
});

var Swim20 = /*#__PURE__*/React.forwardRef(function Swim20(_ref161, ref) {
  var children = _ref161.children,
      rest = _objectWithoutProperties(_ref161, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref162, children);
});

var _ref164 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 26H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 26H2V24H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 24a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 21a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 24a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 24h2zM23 17.5859l-8.707-8.707A2.9791 2.9791 0 0012.1714 8H4v2h8.1714a.9933.9933 0 01.7075.293L15.5859 13 10 18.5859 11.4141 20 17 14.4141 21.5859 19zM20 10a4 4 0 114 4A4.0042 4.0042 0 0120 10zm2 0a2 2 0 102-2A2.0023 2.0023 0 0022 10z"
});

var Swim16 = /*#__PURE__*/React.forwardRef(function Swim16(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref164, children);
});

var _ref166 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
});

var Switcher32 = /*#__PURE__*/React.forwardRef(function Switcher32(_ref165, ref) {
  var children = _ref165.children,
      rest = _objectWithoutProperties(_ref165, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref166, children);
});

var _ref168 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
});

var Switcher24 = /*#__PURE__*/React.forwardRef(function Switcher24(_ref167, ref) {
  var children = _ref167.children,
      rest = _objectWithoutProperties(_ref167, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref168, children);
});

var _ref170 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
});

var Switcher20 = /*#__PURE__*/React.forwardRef(function Switcher20(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref170, children);
});

var _ref172 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 4H18V8H14zM4 4H8V8H4zM24 4H28V8H24zM14 14H18V18H14zM4 14H8V18H4zM24 14H28V18H24zM14 24H18V28H14zM4 24H8V28H4zM24 24H28V28H24z"
});

var Switcher16 = /*#__PURE__*/React.forwardRef(function Switcher16(_ref171, ref) {
  var children = _ref171.children,
      rest = _objectWithoutProperties(_ref171, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref172, children);
});

var _ref174 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 20L21 30 30 25 21 20z"
});

var _ref175 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "14",
  cy: "14",
  r: "2"
});

var _ref176 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
});

var _ref177 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
});

var SysProvision32 = /*#__PURE__*/React.forwardRef(function SysProvision32(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref174, _ref175, _ref176, _ref177, children);
});

var _ref179 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 20L21 30 30 25 21 20z"
});

var _ref180 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "14",
  cy: "14",
  r: "2"
});

var _ref181 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
});

var _ref182 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
});

var SysProvision24 = /*#__PURE__*/React.forwardRef(function SysProvision24(_ref178, ref) {
  var children = _ref178.children,
      rest = _objectWithoutProperties(_ref178, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref179, _ref180, _ref181, _ref182, children);
});

var _ref184 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 20L21 30 30 25 21 20z"
});

var _ref185 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "14",
  cy: "14",
  r: "2"
});

var _ref186 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
});

var _ref187 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
});

var SysProvision20 = /*#__PURE__*/React.forwardRef(function SysProvision20(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref184, _ref185, _ref186, _ref187, children);
});

var _ref189 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 20L21 30 30 25 21 20z"
});

var _ref190 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "14",
  cy: "14",
  r: "2"
});

var _ref191 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,20a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,14,20Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,14,10Z"
});

var _ref192 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.9512,12.91l-.0064,0A12.05,12.05,0,1,0,17,25.605V23.5386a9.9813,9.9813,0,1,1,6.6235-6.81l1.9248.544A12.0341,12.0341,0,0,0,26,14Q26,13.4492,25.9512,12.91Z"
});

var SysProvision16 = /*#__PURE__*/React.forwardRef(function SysProvision16(_ref188, ref) {
  var children = _ref188.children,
      rest = _objectWithoutProperties(_ref188, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref189, _ref190, _ref191, _ref192, children);
});

var _ref194 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
});

var QT32 = /*#__PURE__*/React.forwardRef(function QT32(_ref193, ref) {
  var children = _ref193.children,
      rest = _objectWithoutProperties(_ref193, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref194, children);
});

var _ref196 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
});

var QT24 = /*#__PURE__*/React.forwardRef(function QT24(_ref195, ref) {
  var children = _ref195.children,
      rest = _objectWithoutProperties(_ref195, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref196, children);
});

var _ref198 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
});

var QT20 = /*#__PURE__*/React.forwardRef(function QT20(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref198, children);
});

var _ref200 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 11L15 11 15 23 17 23 17 11 20 11 20 9 12 9 12 11z"
});

var QT16 = /*#__PURE__*/React.forwardRef(function QT16(_ref199, ref) {
  var children = _ref199.children,
      rest = _objectWithoutProperties(_ref199, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref200, children);
});

var _ref202 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
});

var QTAlt32 = /*#__PURE__*/React.forwardRef(function QTAlt32(_ref201, ref) {
  var children = _ref201.children,
      rest = _objectWithoutProperties(_ref201, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref202, children);
});

var _ref204 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
});

var QTAlt24 = /*#__PURE__*/React.forwardRef(function QTAlt24(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref204, children);
});

var _ref206 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
});

var QTAlt20 = /*#__PURE__*/React.forwardRef(function QTAlt20(_ref205, ref) {
  var children = _ref205.children,
      rest = _objectWithoutProperties(_ref205, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref206, children);
});

var _ref208 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 21 18 22 17 22 11 24 11 24 9z"
});

var QTAlt16 = /*#__PURE__*/React.forwardRef(function QTAlt16(_ref207, ref) {
  var children = _ref207.children,
      rest = _objectWithoutProperties(_ref207, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref208, children);
});

var _ref210 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
});

var Table32 = /*#__PURE__*/React.forwardRef(function Table32(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref210, children);
});

var _ref212 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
});

var Table24 = /*#__PURE__*/React.forwardRef(function Table24(_ref211, ref) {
  var children = _ref211.children,
      rest = _objectWithoutProperties(_ref211, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref212, children);
});

var _ref214 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
});

var Table20 = /*#__PURE__*/React.forwardRef(function Table20(_ref213, ref) {
  var children = _ref213.children,
      rest = _objectWithoutProperties(_ref213, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref214, children);
});

var _ref216 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"
});

var Table16 = /*#__PURE__*/React.forwardRef(function Table16(_ref215, ref) {
  var children = _ref215.children,
      rest = _objectWithoutProperties(_ref215, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref216, children);
});

var _ref218 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
});

var TableSplit32 = /*#__PURE__*/React.forwardRef(function TableSplit32(_ref217, ref) {
  var children = _ref217.children,
      rest = _objectWithoutProperties(_ref217, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref218, children);
});

var _ref220 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
});

var TableSplit24 = /*#__PURE__*/React.forwardRef(function TableSplit24(_ref219, ref) {
  var children = _ref219.children,
      rest = _objectWithoutProperties(_ref219, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref220, children);
});

var _ref222 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
});

var TableSplit20 = /*#__PURE__*/React.forwardRef(function TableSplit20(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref222, children);
});

var _ref224 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3Zm0,2V9H5V5ZM17,11H27v7H17Zm-2,7H5V11H15ZM5,20H15v7H5Zm12,7V20H27v7Z"
});

var TableSplit16 = /*#__PURE__*/React.forwardRef(function TableSplit16(_ref223, ref) {
  var children = _ref223.children,
      rest = _objectWithoutProperties(_ref223, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref224, children);
});

var _ref226 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z"
});

var TableOfContents32 = /*#__PURE__*/React.forwardRef(function TableOfContents32(_ref225, ref) {
  var children = _ref225.children,
      rest = _objectWithoutProperties(_ref225, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref226, children);
});

var _ref228 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z"
});

var TableOfContents24 = /*#__PURE__*/React.forwardRef(function TableOfContents24(_ref227, ref) {
  var children = _ref227.children,
      rest = _objectWithoutProperties(_ref227, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref228, children);
});

var _ref230 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z"
});

var TableOfContents20 = /*#__PURE__*/React.forwardRef(function TableOfContents20(_ref229, ref) {
  var children = _ref229.children,
      rest = _objectWithoutProperties(_ref229, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref230, children);
});

var _ref232 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 6H22V8H4zM4 12H22V14H4zM4 18H22V20H4zM4 24H22V26H4zM26 6H28V8H26zM26 12H28V14H26zM26 18H28V20H26zM26 24H28V26H26z"
});

var TableOfContents16 = /*#__PURE__*/React.forwardRef(function TableOfContents16(_ref231, ref) {
  var children = _ref231.children,
      rest = _objectWithoutProperties(_ref231, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref232, children);
});

var _ref234 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 22H17V28H15z",
  transform: "rotate(90 16 25)"
});

var _ref235 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
});

var Tablet32 = /*#__PURE__*/React.forwardRef(function Tablet32(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref234, _ref235, children);
});

var _ref237 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 22H17V28H15z",
  transform: "rotate(90 16 25)"
});

var _ref238 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
});

var Tablet24 = /*#__PURE__*/React.forwardRef(function Tablet24(_ref236, ref) {
  var children = _ref236.children,
      rest = _objectWithoutProperties(_ref236, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref237, _ref238, children);
});

var _ref240 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 22H17V28H15z",
  transform: "rotate(90 16 25)"
});

var _ref241 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
});

var Tablet20 = /*#__PURE__*/React.forwardRef(function Tablet20(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref240, _ref241, children);
});

var _ref243 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 22H17V28H15z",
  transform: "rotate(90 16 25)"
});

var _ref244 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,30H7a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,7,2H25a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,25,30ZM7,4V28H25V4Z"
});

var Tablet16 = /*#__PURE__*/React.forwardRef(function Tablet16(_ref242, ref) {
  var children = _ref242.children,
      rest = _objectWithoutProperties(_ref242, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref243, _ref244, children);
});

var _ref246 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 13H26V19H24z"
});

var _ref247 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
});

var TabletLandscape32 = /*#__PURE__*/React.forwardRef(function TabletLandscape32(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref246, _ref247, children);
});

var _ref249 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 13H26V19H24z"
});

var _ref250 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
});

var TabletLandscape24 = /*#__PURE__*/React.forwardRef(function TabletLandscape24(_ref248, ref) {
  var children = _ref248.children,
      rest = _objectWithoutProperties(_ref248, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref249, _ref250, children);
});

var _ref252 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 13H26V19H24z"
});

var _ref253 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
});

var TabletLandscape20 = /*#__PURE__*/React.forwardRef(function TabletLandscape20(_ref251, ref) {
  var children = _ref251.children,
      rest = _objectWithoutProperties(_ref251, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref252, _ref253, children);
});

var _ref255 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 13H26V19H24z"
});

var _ref256 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,7V25a2.0023,2.0023,0,0,1-2,2H4a2.002,2.002,0,0,1-2-2V7A2.0023,2.0023,0,0,1,4,5H28A2.0027,2.0027,0,0,1,30,7ZM4,25H28V7H4Z"
});

var TabletLandscape16 = /*#__PURE__*/React.forwardRef(function TabletLandscape16(_ref254, ref) {
  var children = _ref254.children,
      rest = _objectWithoutProperties(_ref254, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref255, _ref256, children);
});

var _ref258 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.52,30a3,3,0,0,1-2.12-.88L2.88,15.61A3,3,0,0,1,2,13.49V5A3,3,0,0,1,5,2h8.49a3,3,0,0,1,2.12.88L29.12,16.39a3,3,0,0,1,0,4.25l-8.48,8.48A3,3,0,0,1,18.52,30ZM5,4A1,1,0,0,0,4,5v8.49a1,1,0,0,0,.3.71L17.81,27.71a1,1,0,0,0,1.41,0l8.49-8.49a1,1,0,0,0,0-1.41L14.2,4.3a1,1,0,0,0-.71-.3H5Z"
});

var _ref259 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,14a4,4,0,1,1,4-4A4,4,0,0,1,10,14Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,10,8Z"
});

var Tag32 = /*#__PURE__*/React.forwardRef(function Tag32(_ref257, ref) {
  var children = _ref257.children,
      rest = _objectWithoutProperties(_ref257, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref258, _ref259, children);
});

var _ref261 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.52,30a3,3,0,0,1-2.12-.88L2.88,15.61A3,3,0,0,1,2,13.49V5A3,3,0,0,1,5,2h8.49a3,3,0,0,1,2.12.88L29.12,16.39a3,3,0,0,1,0,4.25l-8.48,8.48A3,3,0,0,1,18.52,30ZM5,4A1,1,0,0,0,4,5v8.49a1,1,0,0,0,.3.71L17.81,27.71a1,1,0,0,0,1.41,0l8.49-8.49a1,1,0,0,0,0-1.41L14.2,4.3a1,1,0,0,0-.71-.3H5Z"
});

var _ref262 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,14a4,4,0,1,1,4-4A4,4,0,0,1,10,14Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,10,8Z"
});

var Tag24 = /*#__PURE__*/React.forwardRef(function Tag24(_ref260, ref) {
  var children = _ref260.children,
      rest = _objectWithoutProperties(_ref260, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref261, _ref262, children);
});

var _ref264 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.52,30a3,3,0,0,1-2.12-.88L2.88,15.61A3,3,0,0,1,2,13.49V5A3,3,0,0,1,5,2h8.49a3,3,0,0,1,2.12.88L29.12,16.39a3,3,0,0,1,0,4.25l-8.48,8.48A3,3,0,0,1,18.52,30ZM5,4A1,1,0,0,0,4,5v8.49a1,1,0,0,0,.3.71L17.81,27.71a1,1,0,0,0,1.41,0l8.49-8.49a1,1,0,0,0,0-1.41L14.2,4.3a1,1,0,0,0-.71-.3H5Z"
});

var _ref265 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,14a4,4,0,1,1,4-4A4,4,0,0,1,10,14Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,10,8Z"
});

var Tag20 = /*#__PURE__*/React.forwardRef(function Tag20(_ref263, ref) {
  var children = _ref263.children,
      rest = _objectWithoutProperties(_ref263, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref264, _ref265, children);
});

var _ref267 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.52,30a3,3,0,0,1-2.12-.88L2.88,15.61A3,3,0,0,1,2,13.49V5A3,3,0,0,1,5,2h8.49a3,3,0,0,1,2.12.88L29.12,16.39a3,3,0,0,1,0,4.25l-8.48,8.48A3,3,0,0,1,18.52,30ZM5,4A1,1,0,0,0,4,5v8.49a1,1,0,0,0,.3.71L17.81,27.71a1,1,0,0,0,1.41,0l8.49-8.49a1,1,0,0,0,0-1.41L14.2,4.3a1,1,0,0,0-.71-.3H5Z"
});

var _ref268 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,14a4,4,0,1,1,4-4A4,4,0,0,1,10,14Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,10,8Z"
});

var Tag16 = /*#__PURE__*/React.forwardRef(function Tag16(_ref266, ref) {
  var children = _ref266.children,
      rest = _objectWithoutProperties(_ref266, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref267, _ref268, children);
});

var _ref270 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 102 2A2.002 2.002 0 0010 8z"
});

var _ref271 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4155,16.5859,27.0364,14.207l-1.4141,1.4141L28,18,18,28,4,14V4H14l4.3774,4.376,1.4141-1.4141L15.4138,2.584A2.0023,2.0023,0,0,0,14,2H4A2.0034,2.0034,0,0,0,2,4V14a2.0025,2.0025,0,0,0,.5842,1.4136l14,14a2.0019,2.0019,0,0,0,2.831,0l10-9.9995A2,2,0,0,0,29.4155,16.5859Z"
});

var TagEdit32 = /*#__PURE__*/React.forwardRef(function TagEdit32(_ref269, ref) {
  var children = _ref269.children,
      rest = _objectWithoutProperties(_ref269, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref270, _ref271, children);
});

var _ref273 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 102 2A2.002 2.002 0 0010 8z"
});

var _ref274 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4155,16.5859,27.0364,14.207l-1.4141,1.4141L28,18,18,28,4,14V4H14l4.3774,4.376,1.4141-1.4141L15.4138,2.584A2.0023,2.0023,0,0,0,14,2H4A2.0034,2.0034,0,0,0,2,4V14a2.0025,2.0025,0,0,0,.5842,1.4136l14,14a2.0019,2.0019,0,0,0,2.831,0l10-9.9995A2,2,0,0,0,29.4155,16.5859Z"
});

var TagEdit24 = /*#__PURE__*/React.forwardRef(function TagEdit24(_ref272, ref) {
  var children = _ref272.children,
      rest = _objectWithoutProperties(_ref272, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref273, _ref274, children);
});

var _ref276 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 102 2A2.002 2.002 0 0010 8z"
});

var _ref277 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4155,16.5859,27.0364,14.207l-1.4141,1.4141L28,18,18,28,4,14V4H14l4.3774,4.376,1.4141-1.4141L15.4138,2.584A2.0023,2.0023,0,0,0,14,2H4A2.0034,2.0034,0,0,0,2,4V14a2.0025,2.0025,0,0,0,.5842,1.4136l14,14a2.0019,2.0019,0,0,0,2.831,0l10-9.9995A2,2,0,0,0,29.4155,16.5859Z"
});

var TagEdit20 = /*#__PURE__*/React.forwardRef(function TagEdit20(_ref275, ref) {
  var children = _ref275.children,
      rest = _objectWithoutProperties(_ref275, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref276, _ref277, children);
});

var _ref279 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.707 7.293l-3-3a.9994.9994 0 00-1.414 0L16 13.5859V18h4.4141L29.707 8.707A.9994.9994 0 0029.707 7.293zM19.5859 16H18V14.4141l5-5L24.5859 11zM26 9.5859L24.4141 8 26 6.4141 27.5859 8zM10 14a4 4 0 114-4A4.0045 4.0045 0 0110 14zm0-6a2 2 0 102 2A2.002 2.002 0 0010 8z"
});

var _ref280 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.4155,16.5859,27.0364,14.207l-1.4141,1.4141L28,18,18,28,4,14V4H14l4.3774,4.376,1.4141-1.4141L15.4138,2.584A2.0023,2.0023,0,0,0,14,2H4A2.0034,2.0034,0,0,0,2,4V14a2.0025,2.0025,0,0,0,.5842,1.4136l14,14a2.0019,2.0019,0,0,0,2.831,0l10-9.9995A2,2,0,0,0,29.4155,16.5859Z"
});

var TagEdit16 = /*#__PURE__*/React.forwardRef(function TagEdit16(_ref278, ref) {
  var children = _ref278.children,
      rest = _objectWithoutProperties(_ref278, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref279, _ref280, children);
});

var _ref282 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "14",
  r: "2"
});

var _ref283 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
});

var _ref284 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
});

var TagGroup32 = /*#__PURE__*/React.forwardRef(function TagGroup32(_ref281, ref) {
  var children = _ref281.children,
      rest = _objectWithoutProperties(_ref281, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref282, _ref283, _ref284, children);
});

var _ref286 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "14",
  r: "2"
});

var _ref287 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
});

var _ref288 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
});

var TagGroup24 = /*#__PURE__*/React.forwardRef(function TagGroup24(_ref285, ref) {
  var children = _ref285.children,
      rest = _objectWithoutProperties(_ref285, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref286, _ref287, _ref288, children);
});

var _ref290 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "14",
  r: "2"
});

var _ref291 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
});

var _ref292 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
});

var TagGroup20 = /*#__PURE__*/React.forwardRef(function TagGroup20(_ref289, ref) {
  var children = _ref289.children,
      rest = _objectWithoutProperties(_ref289, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref290, _ref291, _ref292, children);
});

var _ref294 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "14",
  r: "2"
});

var _ref295 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30a1,1,0,0,1-.71-.29L4.59,19A2,2,0,0,1,4,17.59V10A2,2,0,0,1,6,8h7.59A2,2,0,0,1,15,8.59l10.71,10.7a1,1,0,0,1,0,1.42l-9,9A1,1,0,0,1,16,30ZM6,10v7.59l10,10L23.59,20l-10-10Z"
});

var _ref296 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,13.29,17,2.59A2,2,0,0,0,15.59,2H8A2,2,0,0,0,6,4V6H8V4h7.59l10,10-1.3,1.29,1.42,1.42,2-2A1,1,0,0,0,27.71,13.29Z"
});

var TagGroup16 = /*#__PURE__*/React.forwardRef(function TagGroup16(_ref293, ref) {
  var children = _ref293.children,
      rest = _objectWithoutProperties(_ref293, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref294, _ref295, _ref296, children);
});

var _ref298 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
});

var _ref299 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var Task32 = /*#__PURE__*/React.forwardRef(function Task32(_ref297, ref) {
  var children = _ref297.children,
      rest = _objectWithoutProperties(_ref297, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref298, _ref299, children);
});

var _ref301 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
});

var _ref302 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var Task24 = /*#__PURE__*/React.forwardRef(function Task24(_ref300, ref) {
  var children = _ref300.children,
      rest = _objectWithoutProperties(_ref300, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref301, _ref302, children);
});

var _ref304 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
});

var _ref305 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var Task20 = /*#__PURE__*/React.forwardRef(function Task20(_ref303, ref) {
  var children = _ref303.children,
      rest = _objectWithoutProperties(_ref303, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref304, _ref305, children);
});

var _ref307 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 20.18L10.41 16.59 9 18 14 23 23 14 21.59 12.58 14 20.18z"
});

var _ref308 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
});

var Task16 = /*#__PURE__*/React.forwardRef(function Task16(_ref306, ref) {
  var children = _ref306.children,
      rest = _objectWithoutProperties(_ref306, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref307, _ref308, children);
});

var _ref310 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "24",
  r: "2"
});

var _ref311 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
});

var _ref312 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
});

var _ref313 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
});

var TaskView32 = /*#__PURE__*/React.forwardRef(function TaskView32(_ref309, ref) {
  var children = _ref309.children,
      rest = _objectWithoutProperties(_ref309, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref310, _ref311, _ref312, _ref313, children);
});

var _ref315 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "24",
  r: "2"
});

var _ref316 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
});

var _ref317 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
});

var _ref318 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
});

var TaskView24 = /*#__PURE__*/React.forwardRef(function TaskView24(_ref314, ref) {
  var children = _ref314.children,
      rest = _objectWithoutProperties(_ref314, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref315, _ref316, _ref317, _ref318, children);
});

var _ref320 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "24",
  r: "2"
});

var _ref321 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
});

var _ref322 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
});

var _ref323 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
});

var TaskView20 = /*#__PURE__*/React.forwardRef(function TaskView20(_ref319, ref) {
  var children = _ref319.children,
      rest = _objectWithoutProperties(_ref319, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref320, _ref321, _ref322, _ref323, children);
});

var _ref325 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "24",
  r: "2"
});

var _ref326 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
});

var _ref327 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
});

var _ref328 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
});

var TaskView16 = /*#__PURE__*/React.forwardRef(function TaskView16(_ref324, ref) {
  var children = _ref324.children,
      rest = _objectWithoutProperties(_ref324, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref325, _ref326, _ref327, _ref328, children);
});

var _ref330 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
});

var Taste32 = /*#__PURE__*/React.forwardRef(function Taste32(_ref329, ref) {
  var children = _ref329.children,
      rest = _objectWithoutProperties(_ref329, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref330, children);
});

var _ref332 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
});

var Taste24 = /*#__PURE__*/React.forwardRef(function Taste24(_ref331, ref) {
  var children = _ref331.children,
      rest = _objectWithoutProperties(_ref331, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref332, children);
});

var _ref334 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
});

var Taste20 = /*#__PURE__*/React.forwardRef(function Taste20(_ref333, ref) {
  var children = _ref333.children,
      rest = _objectWithoutProperties(_ref333, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref334, children);
});

var _ref336 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
});

var Taste16 = /*#__PURE__*/React.forwardRef(function Taste16(_ref335, ref) {
  var children = _ref335.children,
      rest = _objectWithoutProperties(_ref335, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref336, children);
});

var _ref338 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
});

var Taxi32 = /*#__PURE__*/React.forwardRef(function Taxi32(_ref337, ref) {
  var children = _ref337.children,
      rest = _objectWithoutProperties(_ref337, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref338, children);
});

var _ref340 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
});

var Taxi24 = /*#__PURE__*/React.forwardRef(function Taxi24(_ref339, ref) {
  var children = _ref339.children,
      rest = _objectWithoutProperties(_ref339, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref340, children);
});

var _ref342 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
});

var Taxi20 = /*#__PURE__*/React.forwardRef(function Taxi20(_ref341, ref) {
  var children = _ref341.children,
      rest = _objectWithoutProperties(_ref341, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref342, children);
});

var _ref344 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
});

var Taxi16 = /*#__PURE__*/React.forwardRef(function Taxi16(_ref343, ref) {
  var children = _ref343.children,
      rest = _objectWithoutProperties(_ref343, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref344, children);
});

var _ref346 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
});

var Temperature32 = /*#__PURE__*/React.forwardRef(function Temperature32(_ref345, ref) {
  var children = _ref345.children,
      rest = _objectWithoutProperties(_ref345, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref346, children);
});

var _ref348 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
});

var Temperature24 = /*#__PURE__*/React.forwardRef(function Temperature24(_ref347, ref) {
  var children = _ref347.children,
      rest = _objectWithoutProperties(_ref347, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref348, children);
});

var _ref350 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
});

var Temperature20 = /*#__PURE__*/React.forwardRef(function Temperature20(_ref349, ref) {
  var children = _ref349.children,
      rest = _objectWithoutProperties(_ref349, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref350, children);
});

var _ref352 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
});

var Temperature16 = /*#__PURE__*/React.forwardRef(function Temperature16(_ref351, ref) {
  var children = _ref351.children,
      rest = _objectWithoutProperties(_ref351, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref352, children);
});

var _ref354 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
});

var _ref355 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,17.2617V6A4,4,0,0,0,5,6V17.2617a7,7,0,1,0,8,0ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V6a2,2,0,0,1,4,0V18.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
});

var TemperatureFrigid32 = /*#__PURE__*/React.forwardRef(function TemperatureFrigid32(_ref353, ref) {
  var children = _ref353.children,
      rest = _objectWithoutProperties(_ref353, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref354, _ref355, children);
});

var _ref357 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
});

var _ref358 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,17.2617V6A4,4,0,0,0,5,6V17.2617a7,7,0,1,0,8,0ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V6a2,2,0,0,1,4,0V18.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
});

var TemperatureFrigid24 = /*#__PURE__*/React.forwardRef(function TemperatureFrigid24(_ref356, ref) {
  var children = _ref356.children,
      rest = _objectWithoutProperties(_ref356, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref357, _ref358, children);
});

var _ref360 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
});

var _ref361 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,17.2617V6A4,4,0,0,0,5,6V17.2617a7,7,0,1,0,8,0ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V6a2,2,0,0,1,4,0V18.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
});

var TemperatureFrigid20 = /*#__PURE__*/React.forwardRef(function TemperatureFrigid20(_ref359, ref) {
  var children = _ref359.children,
      rest = _objectWithoutProperties(_ref359, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref360, _ref361, children);
});

var _ref363 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
});

var _ref364 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,17.2617V6A4,4,0,0,0,5,6V17.2617a7,7,0,1,0,8,0ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V6a2,2,0,0,1,4,0V18.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
});

var TemperatureFrigid16 = /*#__PURE__*/React.forwardRef(function TemperatureFrigid16(_ref362, ref) {
  var children = _ref362.children,
      rest = _objectWithoutProperties(_ref362, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref363, _ref364, children);
});

var _ref366 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.121 19.121H26.121V23.121H24.121z",
  transform: "rotate(-45 25.121 21.121)"
});

var _ref367 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 13H30V15H26z"
});

var _ref368 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.121 5.879H27.121V7.879H23.121z",
  transform: "rotate(-45 25.121 6.879)"
});

var _ref369 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
});

var _ref370 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,18.1377V7A5,5,0,0,0,4,7V18.1377A6.9894,6.9894,0,1,0,16,23,6.9411,6.9411,0,0,0,14,18.1377ZM9,28a5.0057,5.0057,0,0,1-5-5,4.9164,4.9164,0,0,1,1.0747-3.06c.094-.12.1953-.2329.2993-.3437.0518-.0547.1009-.1113.1548-.1636.11-.1064.2271-.2051.3462-.3013.0425-.0346.0815-.0727.125-.1059V7a3,3,0,0,1,6,0V19.0254c.0437.0332.0828.0718.1255.1064.1189.0962.2361.1944.3454.3008.0542.0523.1038.1094.1556.1641.1037.11.205.2236.2988.3432A4.9146,4.9146,0,0,1,14,23,5.0057,5.0057,0,0,1,9,28Z"
});

var TemperatureHot32 = /*#__PURE__*/React.forwardRef(function TemperatureHot32(_ref365, ref) {
  var children = _ref365.children,
      rest = _objectWithoutProperties(_ref365, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref366, _ref367, _ref368, _ref369, _ref370, children);
});

var _ref372 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.121 19.121H26.121V23.121H24.121z",
  transform: "rotate(-45 25.121 21.121)"
});

var _ref373 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 13H30V15H26z"
});

var _ref374 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.121 5.879H27.121V7.879H23.121z",
  transform: "rotate(-45 25.121 6.879)"
});

var _ref375 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
});

var _ref376 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,18.1377V7A5,5,0,0,0,4,7V18.1377A6.9894,6.9894,0,1,0,16,23,6.9411,6.9411,0,0,0,14,18.1377ZM9,28a5.0057,5.0057,0,0,1-5-5,4.9164,4.9164,0,0,1,1.0747-3.06c.094-.12.1953-.2329.2993-.3437.0518-.0547.1009-.1113.1548-.1636.11-.1064.2271-.2051.3462-.3013.0425-.0346.0815-.0727.125-.1059V7a3,3,0,0,1,6,0V19.0254c.0437.0332.0828.0718.1255.1064.1189.0962.2361.1944.3454.3008.0542.0523.1038.1094.1556.1641.1037.11.205.2236.2988.3432A4.9146,4.9146,0,0,1,14,23,5.0057,5.0057,0,0,1,9,28Z"
});

var TemperatureHot24 = /*#__PURE__*/React.forwardRef(function TemperatureHot24(_ref371, ref) {
  var children = _ref371.children,
      rest = _objectWithoutProperties(_ref371, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref372, _ref373, _ref374, _ref375, _ref376, children);
});

var _ref378 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.121 19.121H26.121V23.121H24.121z",
  transform: "rotate(-45 25.121 21.121)"
});

var _ref379 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 13H30V15H26z"
});

var _ref380 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.121 5.879H27.121V7.879H23.121z",
  transform: "rotate(-45 25.121 6.879)"
});

var _ref381 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
});

var _ref382 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,18.1377V7A5,5,0,0,0,4,7V18.1377A6.9894,6.9894,0,1,0,16,23,6.9411,6.9411,0,0,0,14,18.1377ZM9,28a5.0057,5.0057,0,0,1-5-5,4.9164,4.9164,0,0,1,1.0747-3.06c.094-.12.1953-.2329.2993-.3437.0518-.0547.1009-.1113.1548-.1636.11-.1064.2271-.2051.3462-.3013.0425-.0346.0815-.0727.125-.1059V7a3,3,0,0,1,6,0V19.0254c.0437.0332.0828.0718.1255.1064.1189.0962.2361.1944.3454.3008.0542.0523.1038.1094.1556.1641.1037.11.205.2236.2988.3432A4.9146,4.9146,0,0,1,14,23,5.0057,5.0057,0,0,1,9,28Z"
});

var TemperatureHot20 = /*#__PURE__*/React.forwardRef(function TemperatureHot20(_ref377, ref) {
  var children = _ref377.children,
      rest = _objectWithoutProperties(_ref377, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref378, _ref379, _ref380, _ref381, _ref382, children);
});

var _ref384 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24.121 19.121H26.121V23.121H24.121z",
  transform: "rotate(-45 25.121 21.121)"
});

var _ref385 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 13H30V15H26z"
});

var _ref386 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.121 5.879H27.121V7.879H23.121z",
  transform: "rotate(-45 25.121 6.879)"
});

var _ref387 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
});

var _ref388 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,18.1377V7A5,5,0,0,0,4,7V18.1377A6.9894,6.9894,0,1,0,16,23,6.9411,6.9411,0,0,0,14,18.1377ZM9,28a5.0057,5.0057,0,0,1-5-5,4.9164,4.9164,0,0,1,1.0747-3.06c.094-.12.1953-.2329.2993-.3437.0518-.0547.1009-.1113.1548-.1636.11-.1064.2271-.2051.3462-.3013.0425-.0346.0815-.0727.125-.1059V7a3,3,0,0,1,6,0V19.0254c.0437.0332.0828.0718.1255.1064.1189.0962.2361.1944.3454.3008.0542.0523.1038.1094.1556.1641.1037.11.205.2236.2988.3432A4.9146,4.9146,0,0,1,14,23,5.0057,5.0057,0,0,1,9,28Z"
});

var TemperatureHot16 = /*#__PURE__*/React.forwardRef(function TemperatureHot16(_ref383, ref) {
  var children = _ref383.children,
      rest = _objectWithoutProperties(_ref383, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref384, _ref385, _ref386, _ref387, _ref388, children);
});

var _ref390 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
});

var Template32 = /*#__PURE__*/React.forwardRef(function Template32(_ref389, ref) {
  var children = _ref389.children,
      rest = _objectWithoutProperties(_ref389, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref390, children);
});

var _ref392 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
});

var Template24 = /*#__PURE__*/React.forwardRef(function Template24(_ref391, ref) {
  var children = _ref391.children,
      rest = _objectWithoutProperties(_ref391, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref392, children);
});

var _ref394 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
});

var Template20 = /*#__PURE__*/React.forwardRef(function Template20(_ref393, ref) {
  var children = _ref393.children,
      rest = _objectWithoutProperties(_ref393, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref394, children);
});

var _ref396 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
});

var Template16 = /*#__PURE__*/React.forwardRef(function Template16(_ref395, ref) {
  var children = _ref395.children,
      rest = _objectWithoutProperties(_ref395, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref396, children);
});

var _ref398 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: "4",
  height: "4",
  x: "20",
  y: "2",
  rx: "2"
});

var _ref399 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
});

var _ref400 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
});

var Tennis32 = /*#__PURE__*/React.forwardRef(function Tennis32(_ref397, ref) {
  var children = _ref397.children,
      rest = _objectWithoutProperties(_ref397, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref398, _ref399, _ref400, children);
});

var _ref402 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: "4",
  height: "4",
  x: "20",
  y: "2",
  rx: "2"
});

var _ref403 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
});

var _ref404 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
});

var Tennis24 = /*#__PURE__*/React.forwardRef(function Tennis24(_ref401, ref) {
  var children = _ref401.children,
      rest = _objectWithoutProperties(_ref401, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref402, _ref403, _ref404, children);
});

var _ref406 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: "4",
  height: "4",
  x: "20",
  y: "2",
  rx: "2"
});

var _ref407 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
});

var _ref408 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
});

var Tennis20 = /*#__PURE__*/React.forwardRef(function Tennis20(_ref405, ref) {
  var children = _ref405.children,
      rest = _objectWithoutProperties(_ref405, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref406, _ref407, _ref408, children);
});

var _ref410 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: "4",
  height: "4",
  x: "20",
  y: "2",
  rx: "2"
});

var _ref411 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
});

var _ref412 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
});

var Tennis16 = /*#__PURE__*/React.forwardRef(function Tennis16(_ref409, ref) {
  var children = _ref409.children,
      rest = _objectWithoutProperties(_ref409, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref410, _ref411, _ref412, children);
});

var _ref414 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
});

var TennisBall32 = /*#__PURE__*/React.forwardRef(function TennisBall32(_ref413, ref) {
  var children = _ref413.children,
      rest = _objectWithoutProperties(_ref413, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref414, children);
});

var _ref416 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
});

var TennisBall24 = /*#__PURE__*/React.forwardRef(function TennisBall24(_ref415, ref) {
  var children = _ref415.children,
      rest = _objectWithoutProperties(_ref415, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref416, children);
});

var _ref418 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
});

var TennisBall20 = /*#__PURE__*/React.forwardRef(function TennisBall20(_ref417, ref) {
  var children = _ref417.children,
      rest = _objectWithoutProperties(_ref417, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref418, children);
});

var _ref420 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
});

var TennisBall16 = /*#__PURE__*/React.forwardRef(function TennisBall16(_ref419, ref) {
  var children = _ref419.children,
      rest = _objectWithoutProperties(_ref419, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref420, children);
});

var _ref422 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
});

var _ref423 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "16",
  r: "2"
});

var _ref424 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "2"
});

var _ref425 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9",
  cy: "16",
  r: "2"
});

var _ref426 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
});

var Term32 = /*#__PURE__*/React.forwardRef(function Term32(_ref421, ref) {
  var children = _ref421.children,
      rest = _objectWithoutProperties(_ref421, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref422, _ref423, _ref424, _ref425, _ref426, children);
});

var _ref428 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
});

var _ref429 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "16",
  r: "2"
});

var _ref430 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "2"
});

var _ref431 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9",
  cy: "16",
  r: "2"
});

var _ref432 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
});

var Term24 = /*#__PURE__*/React.forwardRef(function Term24(_ref427, ref) {
  var children = _ref427.children,
      rest = _objectWithoutProperties(_ref427, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref428, _ref429, _ref430, _ref431, _ref432, children);
});

var _ref434 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
});

var _ref435 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "16",
  r: "2"
});

var _ref436 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "2"
});

var _ref437 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9",
  cy: "16",
  r: "2"
});

var _ref438 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
});

var Term20 = /*#__PURE__*/React.forwardRef(function Term20(_ref433, ref) {
  var children = _ref433.children,
      rest = _objectWithoutProperties(_ref433, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref434, _ref435, _ref436, _ref437, _ref438, children);
});

var _ref440 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
});

var _ref441 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "16",
  r: "2"
});

var _ref442 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "2"
});

var _ref443 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9",
  cy: "16",
  r: "2"
});

var _ref444 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
});

var Term16 = /*#__PURE__*/React.forwardRef(function Term16(_ref439, ref) {
  var children = _ref439.children,
      rest = _objectWithoutProperties(_ref439, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref440, _ref441, _ref442, _ref443, _ref444, children);
});

var _ref446 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
  transform: "translate(0 .01)"
});

var _ref447 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
});

var Terminal32 = /*#__PURE__*/React.forwardRef(function Terminal32(_ref445, ref) {
  var children = _ref445.children,
      rest = _objectWithoutProperties(_ref445, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref446, _ref447, children);
});

var _ref449 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
  transform: "translate(0 .01)"
});

var _ref450 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
});

var Terminal24 = /*#__PURE__*/React.forwardRef(function Terminal24(_ref448, ref) {
  var children = _ref448.children,
      rest = _objectWithoutProperties(_ref448, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref449, _ref450, children);
});

var _ref452 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
  transform: "translate(0 .01)"
});

var _ref453 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
});

var Terminal20 = /*#__PURE__*/React.forwardRef(function Terminal20(_ref451, ref) {
  var children = _ref451.children,
      rest = _objectWithoutProperties(_ref451, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref452, _ref453, children);
});

var _ref455 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
  transform: "translate(0 .01)"
});

var _ref456 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
});

var Terminal16 = /*#__PURE__*/React.forwardRef(function Terminal16(_ref454, ref) {
  var children = _ref454.children,
      rest = _objectWithoutProperties(_ref454, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref455, _ref456, children);
});

var _ref458 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
});

var TextAlignCenter32 = /*#__PURE__*/React.forwardRef(function TextAlignCenter32(_ref457, ref) {
  var children = _ref457.children,
      rest = _objectWithoutProperties(_ref457, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref458, children);
});

var _ref460 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
});

var TextAlignCenter24 = /*#__PURE__*/React.forwardRef(function TextAlignCenter24(_ref459, ref) {
  var children = _ref459.children,
      rest = _objectWithoutProperties(_ref459, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref460, children);
});

var _ref462 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
});

var TextAlignCenter20 = /*#__PURE__*/React.forwardRef(function TextAlignCenter20(_ref461, ref) {
  var children = _ref461.children,
      rest = _objectWithoutProperties(_ref461, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref462, children);
});

var _ref464 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
});

var TextAlignCenter16 = /*#__PURE__*/React.forwardRef(function TextAlignCenter16(_ref463, ref) {
  var children = _ref463.children,
      rest = _objectWithoutProperties(_ref463, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref464, children);
});

var _ref466 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
});

var TextAlignJustify32 = /*#__PURE__*/React.forwardRef(function TextAlignJustify32(_ref465, ref) {
  var children = _ref465.children,
      rest = _objectWithoutProperties(_ref465, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref466, children);
});

var _ref468 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
});

var TextAlignJustify24 = /*#__PURE__*/React.forwardRef(function TextAlignJustify24(_ref467, ref) {
  var children = _ref467.children,
      rest = _objectWithoutProperties(_ref467, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref468, children);
});

var _ref470 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
});

var TextAlignJustify20 = /*#__PURE__*/React.forwardRef(function TextAlignJustify20(_ref469, ref) {
  var children = _ref469.children,
      rest = _objectWithoutProperties(_ref469, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref470, children);
});

var _ref472 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
});

var TextAlignJustify16 = /*#__PURE__*/React.forwardRef(function TextAlignJustify16(_ref471, ref) {
  var children = _ref471.children,
      rest = _objectWithoutProperties(_ref471, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref472, children);
});

var _ref474 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
});

var TextAlignLeft32 = /*#__PURE__*/React.forwardRef(function TextAlignLeft32(_ref473, ref) {
  var children = _ref473.children,
      rest = _objectWithoutProperties(_ref473, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref474, children);
});

var _ref476 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
});

var TextAlignLeft24 = /*#__PURE__*/React.forwardRef(function TextAlignLeft24(_ref475, ref) {
  var children = _ref475.children,
      rest = _objectWithoutProperties(_ref475, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref476, children);
});

var _ref478 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
});

var TextAlignLeft20 = /*#__PURE__*/React.forwardRef(function TextAlignLeft20(_ref477, ref) {
  var children = _ref477.children,
      rest = _objectWithoutProperties(_ref477, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref478, children);
});

var _ref480 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
});

var TextAlignLeft16 = /*#__PURE__*/React.forwardRef(function TextAlignLeft16(_ref479, ref) {
  var children = _ref479.children,
      rest = _objectWithoutProperties(_ref479, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref480, children);
});

var _ref482 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
});

var TextAlignRight32 = /*#__PURE__*/React.forwardRef(function TextAlignRight32(_ref481, ref) {
  var children = _ref481.children,
      rest = _objectWithoutProperties(_ref481, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref482, children);
});

var _ref484 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
});

var TextAlignRight24 = /*#__PURE__*/React.forwardRef(function TextAlignRight24(_ref483, ref) {
  var children = _ref483.children,
      rest = _objectWithoutProperties(_ref483, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref484, children);
});

var _ref486 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
});

var TextAlignRight20 = /*#__PURE__*/React.forwardRef(function TextAlignRight20(_ref485, ref) {
  var children = _ref485.children,
      rest = _objectWithoutProperties(_ref485, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref486, children);
});

var _ref488 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
});

var TextAlignRight16 = /*#__PURE__*/React.forwardRef(function TextAlignRight16(_ref487, ref) {
  var children = _ref487.children,
      rest = _objectWithoutProperties(_ref487, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref488, children);
});

var _ref490 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M1 8L1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8zM17 8L17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8z"
});

var TextAllCaps32 = /*#__PURE__*/React.forwardRef(function TextAllCaps32(_ref489, ref) {
  var children = _ref489.children,
      rest = _objectWithoutProperties(_ref489, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref490, children);
});

var _ref492 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M1 8L1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8zM17 8L17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8z"
});

var TextAllCaps24 = /*#__PURE__*/React.forwardRef(function TextAllCaps24(_ref491, ref) {
  var children = _ref491.children,
      rest = _objectWithoutProperties(_ref491, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref492, children);
});

var _ref494 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M1 8L1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8zM17 8L17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8z"
});

var TextAllCaps20 = /*#__PURE__*/React.forwardRef(function TextAllCaps20(_ref493, ref) {
  var children = _ref493.children,
      rest = _objectWithoutProperties(_ref493, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref494, children);
});

var _ref496 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M1 8L1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8zM17 8L17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8z"
});

var TextAllCaps16 = /*#__PURE__*/React.forwardRef(function TextAllCaps16(_ref495, ref) {
  var children = _ref495.children,
      rest = _objectWithoutProperties(_ref495, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref496, children);
});

var _ref498 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z"
});

var TextBold32 = /*#__PURE__*/React.forwardRef(function TextBold32(_ref497, ref) {
  var children = _ref497.children,
      rest = _objectWithoutProperties(_ref497, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref498, children);
});

var _ref500 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z"
});

var TextBold24 = /*#__PURE__*/React.forwardRef(function TextBold24(_ref499, ref) {
  var children = _ref499.children,
      rest = _objectWithoutProperties(_ref499, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref500, children);
});

var _ref502 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z"
});

var TextBold20 = /*#__PURE__*/React.forwardRef(function TextBold20(_ref501, ref) {
  var children = _ref501.children,
      rest = _objectWithoutProperties(_ref501, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref502, children);
});

var _ref504 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z"
});

var TextBold16 = /*#__PURE__*/React.forwardRef(function TextBold16(_ref503, ref) {
  var children = _ref503.children,
      rest = _objectWithoutProperties(_ref503, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref504, children);
});

var _ref506 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 21h2L17 4H15L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24H26V28H6z"
});

var TextColor32 = /*#__PURE__*/React.forwardRef(function TextColor32(_ref505, ref) {
  var children = _ref505.children,
      rest = _objectWithoutProperties(_ref505, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref506, children);
});

var _ref508 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 21h2L17 4H15L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24H26V28H6z"
});

var TextColor24 = /*#__PURE__*/React.forwardRef(function TextColor24(_ref507, ref) {
  var children = _ref507.children,
      rest = _objectWithoutProperties(_ref507, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref508, children);
});

var _ref510 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 21h2L17 4H15L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24H26V28H6z"
});

var TextColor20 = /*#__PURE__*/React.forwardRef(function TextColor20(_ref509, ref) {
  var children = _ref509.children,
      rest = _objectWithoutProperties(_ref509, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref510, children);
});

var _ref512 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 21h2L17 4H15L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24H26V28H6z"
});

var TextColor16 = /*#__PURE__*/React.forwardRef(function TextColor16(_ref511, ref) {
  var children = _ref511.children,
      rest = _objectWithoutProperties(_ref511, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref512, children);
});

var _ref514 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
});

var _ref515 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 11L11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11z"
});

var TextCreation32 = /*#__PURE__*/React.forwardRef(function TextCreation32(_ref513, ref) {
  var children = _ref513.children,
      rest = _objectWithoutProperties(_ref513, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref514, _ref515, children);
});

var _ref517 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
});

var _ref518 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 11L11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11z"
});

var TextCreation24 = /*#__PURE__*/React.forwardRef(function TextCreation24(_ref516, ref) {
  var children = _ref516.children,
      rest = _objectWithoutProperties(_ref516, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref517, _ref518, children);
});

var _ref520 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
});

var _ref521 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 11L11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11z"
});

var TextCreation20 = /*#__PURE__*/React.forwardRef(function TextCreation20(_ref519, ref) {
  var children = _ref519.children,
      rest = _objectWithoutProperties(_ref519, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref520, _ref521, children);
});

var _ref523 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
});

var _ref524 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 11L11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11z"
});

var TextCreation16 = /*#__PURE__*/React.forwardRef(function TextCreation16(_ref522, ref) {
  var children = _ref522.children,
      rest = _objectWithoutProperties(_ref522, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref523, _ref524, children);
});

var _ref526 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 26H28V30H4z"
});

var _ref527 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z"
});

var TextFill32 = /*#__PURE__*/React.forwardRef(function TextFill32(_ref525, ref) {
  var children = _ref525.children,
      rest = _objectWithoutProperties(_ref525, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref526, _ref527, children);
});

var _ref529 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 26H28V30H4z"
});

var _ref530 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z"
});

var TextFill24 = /*#__PURE__*/React.forwardRef(function TextFill24(_ref528, ref) {
  var children = _ref528.children,
      rest = _objectWithoutProperties(_ref528, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref529, _ref530, children);
});

var _ref532 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 26H28V30H4z"
});

var _ref533 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z"
});

var TextFill20 = /*#__PURE__*/React.forwardRef(function TextFill20(_ref531, ref) {
  var children = _ref531.children,
      rest = _objectWithoutProperties(_ref531, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref532, _ref533, children);
});

var _ref535 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 26H28V30H4z"
});

var _ref536 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z"
});

var TextFill16 = /*#__PURE__*/React.forwardRef(function TextFill16(_ref534, ref) {
  var children = _ref534.children,
      rest = _objectWithoutProperties(_ref534, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref535, _ref536, children);
});

var _ref538 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15H5a3 3 0 01-3-3V10A3 3 0 015 7h5V5A1 1 0 009 4H3V2H9a3 3 0 013 3zM5 9a1 1 0 00-1 1v2a1 1 0 001 1h5V9zM20 23v2a1 1 0 001 1h5V22H21A1 1 0 0020 23z"
});

var _ref539 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z"
});

var TextHighlight32 = /*#__PURE__*/React.forwardRef(function TextHighlight32(_ref537, ref) {
  var children = _ref537.children,
      rest = _objectWithoutProperties(_ref537, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref538, _ref539, children);
});

var _ref541 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15H5a3 3 0 01-3-3V10A3 3 0 015 7h5V5A1 1 0 009 4H3V2H9a3 3 0 013 3zM5 9a1 1 0 00-1 1v2a1 1 0 001 1h5V9zM20 23v2a1 1 0 001 1h5V22H21A1 1 0 0020 23z"
});

var _ref542 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z"
});

var TextHighlight24 = /*#__PURE__*/React.forwardRef(function TextHighlight24(_ref540, ref) {
  var children = _ref540.children,
      rest = _objectWithoutProperties(_ref540, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref541, _ref542, children);
});

var _ref544 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15H5a3 3 0 01-3-3V10A3 3 0 015 7h5V5A1 1 0 009 4H3V2H9a3 3 0 013 3zM5 9a1 1 0 00-1 1v2a1 1 0 001 1h5V9zM20 23v2a1 1 0 001 1h5V22H21A1 1 0 0020 23z"
});

var _ref545 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z"
});

var TextHighlight20 = /*#__PURE__*/React.forwardRef(function TextHighlight20(_ref543, ref) {
  var children = _ref543.children,
      rest = _objectWithoutProperties(_ref543, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref544, _ref545, children);
});

var _ref547 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15H5a3 3 0 01-3-3V10A3 3 0 015 7h5V5A1 1 0 009 4H3V2H9a3 3 0 013 3zM5 9a1 1 0 00-1 1v2a1 1 0 001 1h5V9zM20 23v2a1 1 0 001 1h5V22H21A1 1 0 0020 23z"
});

var _ref548 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z"
});

var TextHighlight16 = /*#__PURE__*/React.forwardRef(function TextHighlight16(_ref546, ref) {
  var children = _ref546.children,
      rest = _objectWithoutProperties(_ref546, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref547, _ref548, children);
});

var _ref550 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 6H28V8H14zM14 12H28V14H14zM7 18H28V20H7zM7 24H28V26H7zM4 13.59L7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59z"
});

var TextIndent32 = /*#__PURE__*/React.forwardRef(function TextIndent32(_ref549, ref) {
  var children = _ref549.children,
      rest = _objectWithoutProperties(_ref549, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref550, children);
});

var _ref552 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 6H28V8H14zM14 12H28V14H14zM7 18H28V20H7zM7 24H28V26H7zM4 13.59L7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59z"
});

var TextIndent24 = /*#__PURE__*/React.forwardRef(function TextIndent24(_ref551, ref) {
  var children = _ref551.children,
      rest = _objectWithoutProperties(_ref551, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref552, children);
});

var _ref554 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 6H28V8H14zM14 12H28V14H14zM7 18H28V20H7zM7 24H28V26H7zM4 13.59L7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59z"
});

var TextIndent20 = /*#__PURE__*/React.forwardRef(function TextIndent20(_ref553, ref) {
  var children = _ref553.children,
      rest = _objectWithoutProperties(_ref553, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref554, children);
});

var _ref556 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 6H28V8H14zM14 12H28V14H14zM7 18H28V20H7zM7 24H28V26H7zM4 13.59L7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59z"
});

var TextIndent16 = /*#__PURE__*/React.forwardRef(function TextIndent16(_ref555, ref) {
  var children = _ref555.children,
      rest = _objectWithoutProperties(_ref555, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref556, children);
});

var _ref558 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 6H12V8H2zM5 12H12V14H5zM2 18H12V20H2zM5 24H12V26H5zM16 4H18V28H16zM28.15 23.5L29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z"
});

var TextIndentLess32 = /*#__PURE__*/React.forwardRef(function TextIndentLess32(_ref557, ref) {
  var children = _ref557.children,
      rest = _objectWithoutProperties(_ref557, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref558, children);
});

var _ref560 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 6H12V8H2zM5 12H12V14H5zM2 18H12V20H2zM5 24H12V26H5zM16 4H18V28H16zM28.15 23.5L29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z"
});

var TextIndentLess24 = /*#__PURE__*/React.forwardRef(function TextIndentLess24(_ref559, ref) {
  var children = _ref559.children,
      rest = _objectWithoutProperties(_ref559, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref560, children);
});

var _ref562 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 6H12V8H2zM5 12H12V14H5zM2 18H12V20H2zM5 24H12V26H5zM16 4H18V28H16zM28.15 23.5L29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z"
});

var TextIndentLess20 = /*#__PURE__*/React.forwardRef(function TextIndentLess20(_ref561, ref) {
  var children = _ref561.children,
      rest = _objectWithoutProperties(_ref561, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref562, children);
});

var _ref564 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 6H12V8H2zM5 12H12V14H5zM2 18H12V20H2zM5 24H12V26H5zM16 4H18V28H16zM28.15 23.5L29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z"
});

var TextIndentLess16 = /*#__PURE__*/React.forwardRef(function TextIndentLess16(_ref563, ref) {
  var children = _ref563.children,
      rest = _objectWithoutProperties(_ref563, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref564, children);
});

var _ref566 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 6H30V8H20zM20 12H27V14H20zM20 18H30V20H20zM20 24H27V26H20zM14 4H16V28H14zM3.85 22.5L2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z"
});

var TextIndentMore32 = /*#__PURE__*/React.forwardRef(function TextIndentMore32(_ref565, ref) {
  var children = _ref565.children,
      rest = _objectWithoutProperties(_ref565, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref566, children);
});

var _ref568 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 6H30V8H20zM20 12H27V14H20zM20 18H30V20H20zM20 24H27V26H20zM14 4H16V28H14zM3.85 22.5L2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z"
});

var TextIndentMore24 = /*#__PURE__*/React.forwardRef(function TextIndentMore24(_ref567, ref) {
  var children = _ref567.children,
      rest = _objectWithoutProperties(_ref567, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref568, children);
});

var _ref570 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 6H30V8H20zM20 12H27V14H20zM20 18H30V20H20zM20 24H27V26H20zM14 4H16V28H14zM3.85 22.5L2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z"
});

var TextIndentMore20 = /*#__PURE__*/React.forwardRef(function TextIndentMore20(_ref569, ref) {
  var children = _ref569.children,
      rest = _objectWithoutProperties(_ref569, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref570, children);
});

var _ref572 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 6H30V8H20zM20 12H27V14H20zM20 18H30V20H20zM20 24H27V26H20zM14 4H16V28H14zM3.85 22.5L2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z"
});

var TextIndentMore16 = /*#__PURE__*/React.forwardRef(function TextIndentMore16(_ref571, ref) {
  var children = _ref571.children,
      rest = _objectWithoutProperties(_ref571, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref572, children);
});

var _ref574 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 9L25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z"
});

var TextItalic32 = /*#__PURE__*/React.forwardRef(function TextItalic32(_ref573, ref) {
  var children = _ref573.children,
      rest = _objectWithoutProperties(_ref573, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref574, children);
});

var _ref576 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 9L25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z"
});

var TextItalic24 = /*#__PURE__*/React.forwardRef(function TextItalic24(_ref575, ref) {
  var children = _ref575.children,
      rest = _objectWithoutProperties(_ref575, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref576, children);
});

var _ref578 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 9L25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z"
});

var TextItalic20 = /*#__PURE__*/React.forwardRef(function TextItalic20(_ref577, ref) {
  var children = _ref577.children,
      rest = _objectWithoutProperties(_ref577, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref578, children);
});

var _ref580 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 9L25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z"
});

var TextItalic16 = /*#__PURE__*/React.forwardRef(function TextItalic16(_ref579, ref) {
  var children = _ref579.children,
      rest = _objectWithoutProperties(_ref579, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref580, children);
});

var _ref582 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 24L18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24zM14 21L20 4 18 4 12 21 14 21zM13 4L9 16 5 4 3 4 8 18 10 18 15 4 13 4zM28 18h2L25 4H23L18 18h2l1-3h6zm-6.33-5L24 6l2.33 7z"
});

var TextKerning32 = /*#__PURE__*/React.forwardRef(function TextKerning32(_ref581, ref) {
  var children = _ref581.children,
      rest = _objectWithoutProperties(_ref581, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref582, children);
});

var _ref584 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 24L18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24zM14 21L20 4 18 4 12 21 14 21zM13 4L9 16 5 4 3 4 8 18 10 18 15 4 13 4zM28 18h2L25 4H23L18 18h2l1-3h6zm-6.33-5L24 6l2.33 7z"
});

var TextKerning24 = /*#__PURE__*/React.forwardRef(function TextKerning24(_ref583, ref) {
  var children = _ref583.children,
      rest = _objectWithoutProperties(_ref583, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref584, children);
});

var _ref586 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 24L18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24zM14 21L20 4 18 4 12 21 14 21zM13 4L9 16 5 4 3 4 8 18 10 18 15 4 13 4zM28 18h2L25 4H23L18 18h2l1-3h6zm-6.33-5L24 6l2.33 7z"
});

var TextKerning20 = /*#__PURE__*/React.forwardRef(function TextKerning20(_ref585, ref) {
  var children = _ref585.children,
      rest = _objectWithoutProperties(_ref585, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref586, children);
});

var _ref588 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 24L18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24zM14 21L20 4 18 4 12 21 14 21zM13 4L9 16 5 4 3 4 8 18 10 18 15 4 13 4zM28 18h2L25 4H23L18 18h2l1-3h6zm-6.33-5L24 6l2.33 7z"
});

var TextKerning16 = /*#__PURE__*/React.forwardRef(function TextKerning16(_ref587, ref) {
  var children = _ref587.children,
      rest = _objectWithoutProperties(_ref587, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref588, children);
});

var _ref590 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 13H30V15H14zM15 28H30V30H15zM25.85 27H28L23.64 17H21.36L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zM25.85 12H28L23.64 2H21.36L17 12h2.15l.8-2h5.1zm-5.1-4L22.5 3.63 24.25 8zM6 15.83L8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83zM6 27.17L3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z"
});

var TextLeading32 = /*#__PURE__*/React.forwardRef(function TextLeading32(_ref589, ref) {
  var children = _ref589.children,
      rest = _objectWithoutProperties(_ref589, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref590, children);
});

var _ref592 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 13H30V15H14zM15 28H30V30H15zM25.85 27H28L23.64 17H21.36L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zM25.85 12H28L23.64 2H21.36L17 12h2.15l.8-2h5.1zm-5.1-4L22.5 3.63 24.25 8zM6 15.83L8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83zM6 27.17L3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z"
});

var TextLeading24 = /*#__PURE__*/React.forwardRef(function TextLeading24(_ref591, ref) {
  var children = _ref591.children,
      rest = _objectWithoutProperties(_ref591, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref592, children);
});

var _ref594 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 13H30V15H14zM15 28H30V30H15zM25.85 27H28L23.64 17H21.36L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zM25.85 12H28L23.64 2H21.36L17 12h2.15l.8-2h5.1zm-5.1-4L22.5 3.63 24.25 8zM6 15.83L8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83zM6 27.17L3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z"
});

var TextLeading20 = /*#__PURE__*/React.forwardRef(function TextLeading20(_ref593, ref) {
  var children = _ref593.children,
      rest = _objectWithoutProperties(_ref593, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref594, children);
});

var _ref596 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 13H30V15H14zM15 28H30V30H15zM25.85 27H28L23.64 17H21.36L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zM25.85 12H28L23.64 2H21.36L17 12h2.15l.8-2h5.1zm-5.1-4L22.5 3.63 24.25 8zM6 15.83L8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83zM6 27.17L3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z"
});

var TextLeading16 = /*#__PURE__*/React.forwardRef(function TextLeading16(_ref595, ref) {
  var children = _ref595.children,
      rest = _objectWithoutProperties(_ref595, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref596, children);
});

var _ref598 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 6H30V8H17zM17 12H27V14H17zM17 18H30V20H17zM17 24H27V26H17zM11.59 13.41L8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41zM11.59 18.59L8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z"
});

var TextLineSpacing32 = /*#__PURE__*/React.forwardRef(function TextLineSpacing32(_ref597, ref) {
  var children = _ref597.children,
      rest = _objectWithoutProperties(_ref597, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref598, children);
});

var _ref600 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 6H30V8H17zM17 12H27V14H17zM17 18H30V20H17zM17 24H27V26H17zM11.59 13.41L8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41zM11.59 18.59L8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z"
});

var TextLineSpacing24 = /*#__PURE__*/React.forwardRef(function TextLineSpacing24(_ref599, ref) {
  var children = _ref599.children,
      rest = _objectWithoutProperties(_ref599, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref600, children);
});

var _ref602 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 6H30V8H17zM17 12H27V14H17zM17 18H30V20H17zM17 24H27V26H17zM11.59 13.41L8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41zM11.59 18.59L8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z"
});

var TextLineSpacing20 = /*#__PURE__*/React.forwardRef(function TextLineSpacing20(_ref601, ref) {
  var children = _ref601.children,
      rest = _objectWithoutProperties(_ref601, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref602, children);
});

var _ref604 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 6H30V8H17zM17 12H27V14H17zM17 18H30V20H17zM17 24H27V26H17zM11.59 13.41L8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41zM11.59 18.59L8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z"
});

var TextLineSpacing16 = /*#__PURE__*/React.forwardRef(function TextLineSpacing16(_ref603, ref) {
  var children = _ref603.children,
      rest = _objectWithoutProperties(_ref603, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref604, children);
});

var _ref606 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z"
});

var TextNewLine32 = /*#__PURE__*/React.forwardRef(function TextNewLine32(_ref605, ref) {
  var children = _ref605.children,
      rest = _objectWithoutProperties(_ref605, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref606, children);
});

var _ref608 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z"
});

var TextNewLine24 = /*#__PURE__*/React.forwardRef(function TextNewLine24(_ref607, ref) {
  var children = _ref607.children,
      rest = _objectWithoutProperties(_ref607, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref608, children);
});

var _ref610 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z"
});

var TextNewLine20 = /*#__PURE__*/React.forwardRef(function TextNewLine20(_ref609, ref) {
  var children = _ref609.children,
      rest = _objectWithoutProperties(_ref609, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref610, children);
});

var _ref612 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z"
});

var TextNewLine16 = /*#__PURE__*/React.forwardRef(function TextNewLine16(_ref611, ref) {
  var children = _ref611.children,
      rest = _objectWithoutProperties(_ref611, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref612, children);
});

var _ref614 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 5L30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z"
});

var _ref615 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7 26L7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z"
});

var TextScale32 = /*#__PURE__*/React.forwardRef(function TextScale32(_ref613, ref) {
  var children = _ref613.children,
      rest = _objectWithoutProperties(_ref613, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref614, _ref615, children);
});

var _ref617 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 5L30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z"
});

var _ref618 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7 26L7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z"
});

var TextScale24 = /*#__PURE__*/React.forwardRef(function TextScale24(_ref616, ref) {
  var children = _ref616.children,
      rest = _objectWithoutProperties(_ref616, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref617, _ref618, children);
});

var _ref620 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 5L30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z"
});

var _ref621 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7 26L7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z"
});

var TextScale20 = /*#__PURE__*/React.forwardRef(function TextScale20(_ref619, ref) {
  var children = _ref619.children,
      rest = _objectWithoutProperties(_ref619, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref620, _ref621, children);
});

var _ref623 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 5L30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z"
});

var _ref624 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7 26L7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z"
});

var TextScale16 = /*#__PURE__*/React.forwardRef(function TextScale16(_ref622, ref) {
  var children = _ref622.children,
      rest = _objectWithoutProperties(_ref622, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref623, _ref624, children);
});

var _ref626 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 27H21a3 3 0 01-3-3V22a3 3 0 013-3h5V17a1 1 0 00-1-1H19V14h6a3 3 0 013 3zm-7-6a1 1 0 00-1 1v2a1 1 0 001 1h5V21zM13 7h3V5H13a4 4 0 00-3 1.38A4 4 0 007 5H4V7H7A2 2 0 019 9v5H5v2H9v7a2 2 0 01-2 2H4v2H7a4 4 0 003-1.38A4 4 0 0013 27h3V25H13a2 2 0 01-2-2V16h4V14H11V9A2 2 0 0113 7z"
});

var TextSelection32 = /*#__PURE__*/React.forwardRef(function TextSelection32(_ref625, ref) {
  var children = _ref625.children,
      rest = _objectWithoutProperties(_ref625, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref626, children);
});

var _ref628 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 27H21a3 3 0 01-3-3V22a3 3 0 013-3h5V17a1 1 0 00-1-1H19V14h6a3 3 0 013 3zm-7-6a1 1 0 00-1 1v2a1 1 0 001 1h5V21zM13 7h3V5H13a4 4 0 00-3 1.38A4 4 0 007 5H4V7H7A2 2 0 019 9v5H5v2H9v7a2 2 0 01-2 2H4v2H7a4 4 0 003-1.38A4 4 0 0013 27h3V25H13a2 2 0 01-2-2V16h4V14H11V9A2 2 0 0113 7z"
});

var TextSelection24 = /*#__PURE__*/React.forwardRef(function TextSelection24(_ref627, ref) {
  var children = _ref627.children,
      rest = _objectWithoutProperties(_ref627, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref628, children);
});

var _ref630 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 27H21a3 3 0 01-3-3V22a3 3 0 013-3h5V17a1 1 0 00-1-1H19V14h6a3 3 0 013 3zm-7-6a1 1 0 00-1 1v2a1 1 0 001 1h5V21zM13 7h3V5H13a4 4 0 00-3 1.38A4 4 0 007 5H4V7H7A2 2 0 019 9v5H5v2H9v7a2 2 0 01-2 2H4v2H7a4 4 0 003-1.38A4 4 0 0013 27h3V25H13a2 2 0 01-2-2V16h4V14H11V9A2 2 0 0113 7z"
});

var TextSelection20 = /*#__PURE__*/React.forwardRef(function TextSelection20(_ref629, ref) {
  var children = _ref629.children,
      rest = _objectWithoutProperties(_ref629, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref630, children);
});

var _ref632 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 27H21a3 3 0 01-3-3V22a3 3 0 013-3h5V17a1 1 0 00-1-1H19V14h6a3 3 0 013 3zm-7-6a1 1 0 00-1 1v2a1 1 0 001 1h5V21zM13 7h3V5H13a4 4 0 00-3 1.38A4 4 0 007 5H4V7H7A2 2 0 019 9v5H5v2H9v7a2 2 0 01-2 2H4v2H7a4 4 0 003-1.38A4 4 0 0013 27h3V25H13a2 2 0 01-2-2V16h4V14H11V9A2 2 0 0113 7z"
});

var TextSelection16 = /*#__PURE__*/React.forwardRef(function TextSelection16(_ref631, ref) {
  var children = _ref631.children,
      rest = _objectWithoutProperties(_ref631, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref632, children);
});

var _ref634 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23 27L23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z"
});

var _ref635 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 27L11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z"
});

var TextSmallCaps32 = /*#__PURE__*/React.forwardRef(function TextSmallCaps32(_ref633, ref) {
  var children = _ref633.children,
      rest = _objectWithoutProperties(_ref633, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref634, _ref635, children);
});

var _ref637 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23 27L23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z"
});

var _ref638 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 27L11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z"
});

var TextSmallCaps24 = /*#__PURE__*/React.forwardRef(function TextSmallCaps24(_ref636, ref) {
  var children = _ref636.children,
      rest = _objectWithoutProperties(_ref636, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref637, _ref638, children);
});

var _ref640 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23 27L23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z"
});

var _ref641 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 27L11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z"
});

var TextSmallCaps20 = /*#__PURE__*/React.forwardRef(function TextSmallCaps20(_ref639, ref) {
  var children = _ref639.children,
      rest = _objectWithoutProperties(_ref639, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref640, _ref641, children);
});

var _ref643 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23 27L23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z"
});

var _ref644 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 27L11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z"
});

var TextSmallCaps16 = /*#__PURE__*/React.forwardRef(function TextSmallCaps16(_ref642, ref) {
  var children = _ref642.children,
      rest = _objectWithoutProperties(_ref642, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref643, _ref644, children);
});

var _ref646 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z"
});

var TextStrikethrough32 = /*#__PURE__*/React.forwardRef(function TextStrikethrough32(_ref645, ref) {
  var children = _ref645.children,
      rest = _objectWithoutProperties(_ref645, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref646, children);
});

var _ref648 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z"
});

var TextStrikethrough24 = /*#__PURE__*/React.forwardRef(function TextStrikethrough24(_ref647, ref) {
  var children = _ref647.children,
      rest = _objectWithoutProperties(_ref647, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref648, children);
});

var _ref650 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z"
});

var TextStrikethrough20 = /*#__PURE__*/React.forwardRef(function TextStrikethrough20(_ref649, ref) {
  var children = _ref649.children,
      rest = _objectWithoutProperties(_ref649, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref650, children);
});

var _ref652 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z"
});

var TextStrikethrough16 = /*#__PURE__*/React.forwardRef(function TextStrikethrough16(_ref651, ref) {
  var children = _ref651.children,
      rest = _objectWithoutProperties(_ref651, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref652, children);
});

var _ref654 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 25L20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25zM5 7L5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z"
});

var TextSubscript32 = /*#__PURE__*/React.forwardRef(function TextSubscript32(_ref653, ref) {
  var children = _ref653.children,
      rest = _objectWithoutProperties(_ref653, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref654, children);
});

var _ref656 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 25L20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25zM5 7L5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z"
});

var TextSubscript24 = /*#__PURE__*/React.forwardRef(function TextSubscript24(_ref655, ref) {
  var children = _ref655.children,
      rest = _objectWithoutProperties(_ref655, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref656, children);
});

var _ref658 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 25L20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25zM5 7L5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z"
});

var TextSubscript20 = /*#__PURE__*/React.forwardRef(function TextSubscript20(_ref657, ref) {
  var children = _ref657.children,
      rest = _objectWithoutProperties(_ref657, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref658, children);
});

var _ref660 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 25L20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25zM5 7L5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z"
});

var TextSubscript16 = /*#__PURE__*/React.forwardRef(function TextSubscript16(_ref659, ref) {
  var children = _ref659.children,
      rest = _objectWithoutProperties(_ref659, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref660, children);
});

var _ref662 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29 17L23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17zM4 7L4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z"
});

var TextSuperscript32 = /*#__PURE__*/React.forwardRef(function TextSuperscript32(_ref661, ref) {
  var children = _ref661.children,
      rest = _objectWithoutProperties(_ref661, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref662, children);
});

var _ref664 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29 17L23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17zM4 7L4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z"
});

var TextSuperscript24 = /*#__PURE__*/React.forwardRef(function TextSuperscript24(_ref663, ref) {
  var children = _ref663.children,
      rest = _objectWithoutProperties(_ref663, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref664, children);
});

var _ref666 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29 17L23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17zM4 7L4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z"
});

var TextSuperscript20 = /*#__PURE__*/React.forwardRef(function TextSuperscript20(_ref665, ref) {
  var children = _ref665.children,
      rest = _objectWithoutProperties(_ref665, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref666, children);
});

var _ref668 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29 17L23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17zM4 7L4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z"
});

var TextSuperscript16 = /*#__PURE__*/React.forwardRef(function TextSuperscript16(_ref667, ref) {
  var children = _ref667.children,
      rest = _objectWithoutProperties(_ref667, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref668, children);
});

var _ref670 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.29 19.29L23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29zM26 17h2L23 3H21L16 17h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3L10 15 6 3 4 3 9 17 11 17 16 3 14 3z"
});

var TextTracking32 = /*#__PURE__*/React.forwardRef(function TextTracking32(_ref669, ref) {
  var children = _ref669.children,
      rest = _objectWithoutProperties(_ref669, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref670, children);
});

var _ref672 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.29 19.29L23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29zM26 17h2L23 3H21L16 17h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3L10 15 6 3 4 3 9 17 11 17 16 3 14 3z"
});

var TextTracking24 = /*#__PURE__*/React.forwardRef(function TextTracking24(_ref671, ref) {
  var children = _ref671.children,
      rest = _objectWithoutProperties(_ref671, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref672, children);
});

var _ref674 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.29 19.29L23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29zM26 17h2L23 3H21L16 17h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3L10 15 6 3 4 3 9 17 11 17 16 3 14 3z"
});

var TextTracking20 = /*#__PURE__*/React.forwardRef(function TextTracking20(_ref673, ref) {
  var children = _ref673.children,
      rest = _objectWithoutProperties(_ref673, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref674, children);
});

var _ref676 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.29 19.29L23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29zM26 17h2L23 3H21L16 17h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3L10 15 6 3 4 3 9 17 11 17 16 3 14 3z"
});

var TextTracking16 = /*#__PURE__*/React.forwardRef(function TextTracking16(_ref675, ref) {
  var children = _ref675.children,
      rest = _objectWithoutProperties(_ref675, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref676, children);
});

var _ref678 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 26H28V28H4zM16 23a7 7 0 01-7-7V5h2V16a5 5 0 0010 0V5h2V16A7 7 0 0116 23z"
});

var TextUnderline32 = /*#__PURE__*/React.forwardRef(function TextUnderline32(_ref677, ref) {
  var children = _ref677.children,
      rest = _objectWithoutProperties(_ref677, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref678, children);
});

var _ref680 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 26H28V28H4zM16 23a7 7 0 01-7-7V5h2V16a5 5 0 0010 0V5h2V16A7 7 0 0116 23z"
});

var TextUnderline24 = /*#__PURE__*/React.forwardRef(function TextUnderline24(_ref679, ref) {
  var children = _ref679.children,
      rest = _objectWithoutProperties(_ref679, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref680, children);
});

var _ref682 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 26H28V28H4zM16 23a7 7 0 01-7-7V5h2V16a5 5 0 0010 0V5h2V16A7 7 0 0116 23z"
});

var TextUnderline20 = /*#__PURE__*/React.forwardRef(function TextUnderline20(_ref681, ref) {
  var children = _ref681.children,
      rest = _objectWithoutProperties(_ref681, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref682, children);
});

var _ref684 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 26H28V28H4zM16 23a7 7 0 01-7-7V5h2V16a5 5 0 0010 0V5h2V16A7 7 0 0116 23z"
});

var TextUnderline16 = /*#__PURE__*/React.forwardRef(function TextUnderline16(_ref683, ref) {
  var children = _ref683.children,
      rest = _objectWithoutProperties(_ref683, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref684, children);
});

var _ref686 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28H30V30H16zM16 23H30V25H16zM10.8458 30H13L8.64 20H6.36L2 30H4.1542l.8-2h5.0916zM5.7541 26L7.5 21.6347 9.2459 26zM2 15H30V17H2zM16 7H30V9H16zM16 2H30V4H16zM10.8458 12H13L8.64 2H6.36L2 12H4.1542l.8-2h5.0916zM5.7541 8L7.5 3.6347 9.2459 8z"
});

var TextVerticalAlignment32 = /*#__PURE__*/React.forwardRef(function TextVerticalAlignment32(_ref685, ref) {
  var children = _ref685.children,
      rest = _objectWithoutProperties(_ref685, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref686, children);
});

var _ref688 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28H30V30H16zM16 23H30V25H16zM10.8458 30H13L8.64 20H6.36L2 30H4.1542l.8-2h5.0916zM5.7541 26L7.5 21.6347 9.2459 26zM2 15H30V17H2zM16 7H30V9H16zM16 2H30V4H16zM10.8458 12H13L8.64 2H6.36L2 12H4.1542l.8-2h5.0916zM5.7541 8L7.5 3.6347 9.2459 8z"
});

var TextVerticalAlignment24 = /*#__PURE__*/React.forwardRef(function TextVerticalAlignment24(_ref687, ref) {
  var children = _ref687.children,
      rest = _objectWithoutProperties(_ref687, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref688, children);
});

var _ref690 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28H30V30H16zM16 23H30V25H16zM10.8458 30H13L8.64 20H6.36L2 30H4.1542l.8-2h5.0916zM5.7541 26L7.5 21.6347 9.2459 26zM2 15H30V17H2zM16 7H30V9H16zM16 2H30V4H16zM10.8458 12H13L8.64 2H6.36L2 12H4.1542l.8-2h5.0916zM5.7541 8L7.5 3.6347 9.2459 8z"
});

var TextVerticalAlignment20 = /*#__PURE__*/React.forwardRef(function TextVerticalAlignment20(_ref689, ref) {
  var children = _ref689.children,
      rest = _objectWithoutProperties(_ref689, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref690, children);
});

var _ref692 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28H30V30H16zM16 23H30V25H16zM10.8458 30H13L8.64 20H6.36L2 30H4.1542l.8-2h5.0916zM5.7541 26L7.5 21.6347 9.2459 26zM2 15H30V17H2zM16 7H30V9H16zM16 2H30V4H16zM10.8458 12H13L8.64 2H6.36L2 12H4.1542l.8-2h5.0916zM5.7541 8L7.5 3.6347 9.2459 8z"
});

var TextVerticalAlignment16 = /*#__PURE__*/React.forwardRef(function TextVerticalAlignment16(_ref691, ref) {
  var children = _ref691.children,
      rest = _objectWithoutProperties(_ref691, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref692, children);
});

var _ref694 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 23H12V25H4zM24.5232 14H4v2H24.5a3.5 3.5 0 010 7H18.8281l2.586-2.5859L20 19l-5 5 5 5 1.4141-1.4141L18.8281 25H24.533a5.5 5.5 0 00-.01-11zM4 5H28V7H4z"
});

var TextWrap32 = /*#__PURE__*/React.forwardRef(function TextWrap32(_ref693, ref) {
  var children = _ref693.children,
      rest = _objectWithoutProperties(_ref693, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref694, children);
});

var _ref696 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 23H12V25H4zM24.5232 14H4v2H24.5a3.5 3.5 0 010 7H18.8281l2.586-2.5859L20 19l-5 5 5 5 1.4141-1.4141L18.8281 25H24.533a5.5 5.5 0 00-.01-11zM4 5H28V7H4z"
});

var TextWrap24 = /*#__PURE__*/React.forwardRef(function TextWrap24(_ref695, ref) {
  var children = _ref695.children,
      rest = _objectWithoutProperties(_ref695, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref696, children);
});

var _ref698 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 23H12V25H4zM24.5232 14H4v2H24.5a3.5 3.5 0 010 7H18.8281l2.586-2.5859L20 19l-5 5 5 5 1.4141-1.4141L18.8281 25H24.533a5.5 5.5 0 00-.01-11zM4 5H28V7H4z"
});

var TextWrap20 = /*#__PURE__*/React.forwardRef(function TextWrap20(_ref697, ref) {
  var children = _ref697.children,
      rest = _objectWithoutProperties(_ref697, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref698, children);
});

var _ref700 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 23H12V25H4zM24.5232 14H4v2H24.5a3.5 3.5 0 010 7H18.8281l2.586-2.5859L20 19l-5 5 5 5 1.4141-1.4141L18.8281 25H24.533a5.5 5.5 0 00-.01-11zM4 5H28V7H4z"
});

var TextWrap16 = /*#__PURE__*/React.forwardRef(function TextWrap16(_ref699, ref) {
  var children = _ref699.children,
      rest = _objectWithoutProperties(_ref699, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref700, children);
});

var _ref702 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.537 13.76L26.24 10.463a1.5862 1.5862 0 00-2.24 0L10 24.4674V30h5.5326L29.537 16a1.5862 1.5862 0 000-2.24zM14.7042 28H12V25.2958l9.4409-9.4409 2.7042 2.7042zM25.5591 17.145L22.855 14.4409l2.2672-2.2672 2.7042 2.7042zM11 17L13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z"
});

var _ref703 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z"
});

var WatsonHealthTextAnnotationToggle32 = /*#__PURE__*/React.forwardRef(function WatsonHealthTextAnnotationToggle32(_ref701, ref) {
  var children = _ref701.children,
      rest = _objectWithoutProperties(_ref701, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref702, _ref703, children);
});

var _ref705 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.537 13.76L26.24 10.463a1.5862 1.5862 0 00-2.24 0L10 24.4674V30h5.5326L29.537 16a1.5862 1.5862 0 000-2.24zM14.7042 28H12V25.2958l9.4409-9.4409 2.7042 2.7042zM25.5591 17.145L22.855 14.4409l2.2672-2.2672 2.7042 2.7042zM11 17L13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z"
});

var _ref706 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z"
});

var WatsonHealthTextAnnotationToggle24 = /*#__PURE__*/React.forwardRef(function WatsonHealthTextAnnotationToggle24(_ref704, ref) {
  var children = _ref704.children,
      rest = _objectWithoutProperties(_ref704, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref705, _ref706, children);
});

var _ref708 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.537 13.76L26.24 10.463a1.5862 1.5862 0 00-2.24 0L10 24.4674V30h5.5326L29.537 16a1.5862 1.5862 0 000-2.24zM14.7042 28H12V25.2958l9.4409-9.4409 2.7042 2.7042zM25.5591 17.145L22.855 14.4409l2.2672-2.2672 2.7042 2.7042zM11 17L13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z"
});

var _ref709 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z"
});

var WatsonHealthTextAnnotationToggle20 = /*#__PURE__*/React.forwardRef(function WatsonHealthTextAnnotationToggle20(_ref707, ref) {
  var children = _ref707.children,
      rest = _objectWithoutProperties(_ref707, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref708, _ref709, children);
});

var _ref711 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.537 13.76L26.24 10.463a1.5862 1.5862 0 00-2.24 0L10 24.4674V30h5.5326L29.537 16a1.5862 1.5862 0 000-2.24zM14.7042 28H12V25.2958l9.4409-9.4409 2.7042 2.7042zM25.5591 17.145L22.855 14.4409l2.2672-2.2672 2.7042 2.7042zM11 17L13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z"
});

var _ref712 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z"
});

var WatsonHealthTextAnnotationToggle16 = /*#__PURE__*/React.forwardRef(function WatsonHealthTextAnnotationToggle16(_ref710, ref) {
  var children = _ref710.children,
      rest = _objectWithoutProperties(_ref710, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref711, _ref712, children);
});

var _ref714 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z"
});

var _ref715 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.2642 29.9971A5.2619 5.2619 0 016.542 21.0137l6.03-6.03a5.2636 5.2636 0 117.4438 7.4438l-1.414-1.414a3.2639 3.2639 0 10-4.6158-4.6158l-6.03 6.03a3.264 3.264 0 004.6157 4.6162l1.414 1.4141A5.2452 5.2452 0 0110.2642 29.9971zM2 10H10V12H2zM2 6H14V8H2zM2 2H14V4H2z"
});

var TextLink32 = /*#__PURE__*/React.forwardRef(function TextLink32(_ref713, ref) {
  var children = _ref713.children,
      rest = _objectWithoutProperties(_ref713, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref714, _ref715, children);
});

var _ref717 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z"
});

var _ref718 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.2642 29.9971A5.2619 5.2619 0 016.542 21.0137l6.03-6.03a5.2636 5.2636 0 117.4438 7.4438l-1.414-1.414a3.2639 3.2639 0 10-4.6158-4.6158l-6.03 6.03a3.264 3.264 0 004.6157 4.6162l1.414 1.4141A5.2452 5.2452 0 0110.2642 29.9971zM2 10H10V12H2zM2 6H14V8H2zM2 2H14V4H2z"
});

var TextLink24 = /*#__PURE__*/React.forwardRef(function TextLink24(_ref716, ref) {
  var children = _ref716.children,
      rest = _objectWithoutProperties(_ref716, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref717, _ref718, children);
});

var _ref720 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z"
});

var _ref721 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.2642 29.9971A5.2619 5.2619 0 016.542 21.0137l6.03-6.03a5.2636 5.2636 0 117.4438 7.4438l-1.414-1.414a3.2639 3.2639 0 10-4.6158-4.6158l-6.03 6.03a3.264 3.264 0 004.6157 4.6162l1.414 1.4141A5.2452 5.2452 0 0110.2642 29.9971zM2 10H10V12H2zM2 6H14V8H2zM2 2H14V4H2z"
});

var TextLink20 = /*#__PURE__*/React.forwardRef(function TextLink20(_ref719, ref) {
  var children = _ref719.children,
      rest = _objectWithoutProperties(_ref719, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref720, _ref721, children);
});

var _ref723 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z"
});

var _ref724 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.2642 29.9971A5.2619 5.2619 0 016.542 21.0137l6.03-6.03a5.2636 5.2636 0 117.4438 7.4438l-1.414-1.414a3.2639 3.2639 0 10-4.6158-4.6158l-6.03 6.03a3.264 3.264 0 004.6157 4.6162l1.414 1.4141A5.2452 5.2452 0 0110.2642 29.9971zM2 10H10V12H2zM2 6H14V8H2zM2 2H14V4H2z"
});

var TextLink16 = /*#__PURE__*/React.forwardRef(function TextLink16(_ref722, ref) {
  var children = _ref722.children,
      rest = _objectWithoutProperties(_ref722, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref723, _ref724, children);
});

var _ref726 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 10H16V12H8zM8 6H20V8H8zM8 2H20V4H8z"
});

var _ref727 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
});

var TextLinkAnalysis32 = /*#__PURE__*/React.forwardRef(function TextLinkAnalysis32(_ref725, ref) {
  var children = _ref725.children,
      rest = _objectWithoutProperties(_ref725, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref726, _ref727, children);
});

var _ref729 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 10H16V12H8zM8 6H20V8H8zM8 2H20V4H8z"
});

var _ref730 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
});

var TextLinkAnalysis24 = /*#__PURE__*/React.forwardRef(function TextLinkAnalysis24(_ref728, ref) {
  var children = _ref728.children,
      rest = _objectWithoutProperties(_ref728, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref729, _ref730, children);
});

var _ref732 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 10H16V12H8zM8 6H20V8H8zM8 2H20V4H8z"
});

var _ref733 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
});

var TextLinkAnalysis20 = /*#__PURE__*/React.forwardRef(function TextLinkAnalysis20(_ref731, ref) {
  var children = _ref731.children,
      rest = _objectWithoutProperties(_ref731, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref732, _ref733, children);
});

var _ref735 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 10H16V12H8zM8 6H20V8H8zM8 2H20V4H8z"
});

var _ref736 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
});

var TextLinkAnalysis16 = /*#__PURE__*/React.forwardRef(function TextLinkAnalysis16(_ref734, ref) {
  var children = _ref734.children,
      rest = _objectWithoutProperties(_ref734, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref735, _ref736, children);
});

var _ref738 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 28H26V30H18zM18 24H30V26H18zM18 20H30V22H18z"
});

var _ref739 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
});

var TextMining32 = /*#__PURE__*/React.forwardRef(function TextMining32(_ref737, ref) {
  var children = _ref737.children,
      rest = _objectWithoutProperties(_ref737, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref738, _ref739, children);
});

var _ref741 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 28H26V30H18zM18 24H30V26H18zM18 20H30V22H18z"
});

var _ref742 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
});

var TextMining24 = /*#__PURE__*/React.forwardRef(function TextMining24(_ref740, ref) {
  var children = _ref740.children,
      rest = _objectWithoutProperties(_ref740, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref741, _ref742, children);
});
export { QT16, QT20, QT24, QT32, QTAlt16, QTAlt20, QTAlt24, QTAlt32, SubtractAlt16, SubtractAlt20, SubtractAlt24, SubtractAlt32, Sun16, Sun20, Sun24, Sun32, Sunny16, Sunny20, Sunny24, Sunny32, Sunrise16, Sunrise20, Sunrise24, Sunrise32, Sunset16, Sunset20, Sunset24, Sunset32, Svg16, Svg20, Svg24, Svg32, Swim16, Swim20, Swim24, Swim32, Switcher16, Switcher20, Switcher24, Switcher32, SysProvision16, SysProvision20, SysProvision24, SysProvision32, Table16, Table20, Table24, Table32, TableOfContents16, TableOfContents20, TableOfContents24, TableOfContents32, TableSplit16, TableSplit20, TableSplit24, TableSplit32, Tablet16, Tablet20, Tablet24, Tablet32, TabletLandscape16, TabletLandscape20, TabletLandscape24, TabletLandscape32, Tag16, Tag20, Tag24, Tag32, TagEdit16, TagEdit20, TagEdit24, TagEdit32, TagGroup16, TagGroup20, TagGroup24, TagGroup32, Task16, Task20, Task24, Task32, TaskView16, TaskView20, TaskView24, TaskView32, Taste16, Taste20, Taste24, Taste32, Taxi16, Taxi20, Taxi24, Taxi32, Temperature16, Temperature20, Temperature24, Temperature32, TemperatureFrigid16, TemperatureFrigid20, TemperatureFrigid24, TemperatureFrigid32, TemperatureHot16, TemperatureHot20, TemperatureHot24, TemperatureHot32, Template16, Template20, Template24, Template32, Tennis16, Tennis20, Tennis24, Tennis32, TennisBall16, TennisBall20, TennisBall24, TennisBall32, Term16, Term20, Term24, Term32, Terminal16, Terminal20, Terminal24, Terminal32, TextAlignCenter16, TextAlignCenter20, TextAlignCenter24, TextAlignCenter32, TextAlignJustify16, TextAlignJustify20, TextAlignJustify24, TextAlignJustify32, TextAlignLeft16, TextAlignLeft20, TextAlignLeft24, TextAlignLeft32, TextAlignRight16, TextAlignRight20, TextAlignRight24, TextAlignRight32, TextAllCaps16, TextAllCaps20, TextAllCaps24, TextAllCaps32, TextBold16, TextBold20, TextBold24, TextBold32, TextColor16, TextColor20, TextColor24, TextColor32, TextCreation16, TextCreation20, TextCreation24, TextCreation32, TextFill16, TextFill20, TextFill24, TextFill32, TextHighlight16, TextHighlight20, TextHighlight24, TextHighlight32, TextIndent16, TextIndent20, TextIndent24, TextIndent32, TextIndentLess16, TextIndentLess20, TextIndentLess24, TextIndentLess32, TextIndentMore16, TextIndentMore20, TextIndentMore24, TextIndentMore32, TextItalic16, TextItalic20, TextItalic24, TextItalic32, TextKerning16, TextKerning20, TextKerning24, TextKerning32, TextLeading16, TextLeading20, TextLeading24, TextLeading32, TextLineSpacing16, TextLineSpacing20, TextLineSpacing24, TextLineSpacing32, TextLink16, TextLink20, TextLink24, TextLink32, TextLinkAnalysis16, TextLinkAnalysis20, TextLinkAnalysis24, TextLinkAnalysis32, TextMining24, TextMining32, TextNewLine16, TextNewLine20, TextNewLine24, TextNewLine32, TextScale16, TextScale20, TextScale24, TextScale32, TextSelection16, TextSelection20, TextSelection24, TextSelection32, TextSmallCaps16, TextSmallCaps20, TextSmallCaps24, TextSmallCaps32, TextStrikethrough16, TextStrikethrough20, TextStrikethrough24, TextStrikethrough32, TextSubscript16, TextSubscript20, TextSubscript24, TextSubscript32, TextSuperscript16, TextSuperscript20, TextSuperscript24, TextSuperscript32, TextTracking16, TextTracking20, TextTracking24, TextTracking32, TextUnderline16, TextUnderline20, TextUnderline24, TextUnderline32, TextVerticalAlignment16, TextVerticalAlignment20, TextVerticalAlignment24, TextVerticalAlignment32, TextWrap16, TextWrap20, TextWrap24, TextWrap32, WatsonHealthTextAnnotationToggle16, WatsonHealthTextAnnotationToggle20, WatsonHealthTextAnnotationToggle24, WatsonHealthTextAnnotationToggle32 };